import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemSfName, FormItemSfNo} from '../SF/FormChooseSf.jsx'

export default function FormChooseSf(props) {
    return (
        <FormChooseDesign {...props}>
            <FormItemSfNo />
            <FormItemSfName />
        </FormChooseDesign>
    )
}
